import axios from "axios";
import toQueryString from "../common/utils/to-query-string";

const get = (query) => axios.get(toQueryString(`/api/v1/facts?`, query));

const getById = (id, query) => axios.get(toQueryString(`/api/v1/facts/${id}?`, query));

const create = (params) => axios.post(`/api/v1/facts`, params);

const update = (id, params) => axios.put(`/api/v1/facts/${id}`, params);

const remove = (id) => axios.delete(`/api/v1/facts/${id}`);

const removeBulk = (ids) => axios.delete(`/api/v1/facts/bulk`, { data: { ids } });

const getTags = () => axios.get("/api/v1/fact-tags");

const getCategories = () => axios.get("/api/v1/categories");

const publish = (id, params) => axios.put(`/api/v1/facts/${id}/publish`, params);

const discard = (id, params) => axios.put(`/api/v1/facts/${id}/discard`, params);

const toggleStatus = (id, params) => axios.put(`/api/v1/facts/${id}/toggle-status`, params);

const ApiLifeFacts = {
  get,
  create,
  update,
  remove,
  removeBulk,
  getTags,
  getCategories,
  publish,
  discard,
  toggleStatus,
  getById
};

export default ApiLifeFacts;
